export default "__VITE_ASSET__DkTZTD2e__"